import { CART } from "constants/types";

const initState = {
  cart: []
}


const CartReducer = (state = initState, action) => {

  const { type, payload, shop, quantity } = action;

  switch(type) {

    case CART.ADD:

      let isNew = true;

      let updatedN = state.cart.map((item) => {

        if(item.uniqid === payload.uniqid) {
          item.quantity = item.quantity + quantity;
          isNew = false;
        }

        return item
      });

      if(isNew) {
         updatedN.push({
           ...payload,
           quantity: quantity
         })
      }

      localStorage.setItem(`cart-${shop}`, JSON.stringify(updatedN))
      return {
        ...state,
        cart: [
          ...updatedN
        ],
      }

    case CART.ADD_PURE:

      let updatedPure = state.cart.map((item) => {
        if(item.uniqid === payload.uniqid) {
          item.quantity = quantity;
        }
        return item
      });

      localStorage.setItem(`cart-${shop}`, JSON.stringify(updatedPure))
      return {
        ...state,
        cart: [
          ...updatedPure
        ],
      }


    case CART.REMOVE:

      let updated = state.cart.map((item) => {
          if(item.uniqid === payload) {
            if(quantity === -1) {
              item.quantity = 0;
            } else {
              item.quantity = item.quantity - quantity;
            }
          }

          return item
      });

      if(!updated.filter(item => item.quantity).length) {
        localStorage.removeItem(`cart-${shop}`);
      }

      localStorage.setItem(`cart-${shop}`, JSON.stringify(updated.filter(item => item.quantity)))
      return {
        ...state,
        cart: [
          ...updated.filter(item => item.quantity)
        ],
      }

    case CART.CLEAR:

      localStorage.removeItem(`cart-${payload}`);

      return {
        ...state,
        cart: []
      }

    case CART.UPDATE:

      let name = payload[Object.keys(payload)[0]].name;

      let c = state.cart.map(({ uniqid, quantity }) => {
        return {
          ...payload[uniqid],
          quantity
        }
      })

      localStorage.setItem(`cart-${name}`, JSON.stringify(c));
      return {
        ...state,
        cart: [...c]
      }

    case CART.SET:
      return {
        ...state,
        cart: [...payload]
      }

    default:
      return state
  }
}

export default CartReducer